import { FormControl, FormGroup, Validators } from '@angular/forms';
import { StringUtility } from '../utility/string.utility';
import { CallingTreeAssignmentsValidator } from '../validators/calling-tree-assignments.validator';
import { IsNotMatchValidator } from '../validators/is-not-match.validator';
import { BaseResponse } from './base-response.model';
import { UserDropDownJSON } from './user-drop-down.model';

export interface CallingTreeAssignmentsJSON {
	branch: number;
	activeCoordinatorId: number;
	activeCoordinatorNetId: string;
	activeCoordinatorLastName: string;
	activeCoordinatorFirstName: string;
	backupCoordinatorId: number;
	backupCoordinatorNetId: string;
	backupCoordinatorLastName: string;
	backupCoordinatorFirstName: string;
}

export class CallingTreeAssignments {
	constructor(
		public branch: number,
		public activeCoordinatorId: number,
		public activeCoordinatorNetId: string,
		public activeCoordinatorLastName: string,
		public activeCoordinatorFirstName: string,
		public backupCoordinatorId: number,
		public backupCoordinatorNetId: string,
		public backupCoordinatorLastName: string,
		public backupCoordinatorFirstName: string
	) {}

	get activeCoordinatorName(): string {
		return StringUtility.lastFirstName(
			this.activeCoordinatorLastName,
			this.activeCoordinatorFirstName,
			this.activeCoordinatorNetId
		);
	}

	get backupCoordinatorName(): string {
		return StringUtility.lastFirstName(
			this.backupCoordinatorLastName,
			this.backupCoordinatorFirstName,
			this.backupCoordinatorNetId
		);
	}

	static fromJSON(json: CallingTreeAssignmentsJSON): CallingTreeAssignments {
		return Object.assign(
			Object.create(CallingTreeAssignments.prototype),
			json,
			{}
		);
	}

	static createFormGroup(
		assignments: CallingTreeAssignments,
		branchMemberIds: number[],
		userId: number
	): FormGroup<CallingTreeAssignmentsFormGroup> {
		if (assignments == null || branchMemberIds == null) {
			return null;
		}
		const fg: FormGroup<CallingTreeAssignmentsFormGroup> =
			new FormGroup<CallingTreeAssignmentsFormGroup>({
				assignments: new FormControl(assignments),
				activeCoordinatorId: new FormControl(
					branchMemberIds.includes(assignments.activeCoordinatorId)
						? assignments.activeCoordinatorId
						: null,
					[Validators.required, IsNotMatchValidator(userId)]
				),
				backupCoordinatorId: new FormControl(
					branchMemberIds.includes(assignments.backupCoordinatorId)
						? assignments.backupCoordinatorId
						: null,
					[Validators.required, IsNotMatchValidator(userId)]
				),
			});
		fg.setValidators([
			CallingTreeAssignmentsValidator(
				fg.get('activeCoordinatorId'),
				fg.get('backupCoordinatorId')
			),
		]);
		fg.markAllAsTouched();
		return fg;
	}

	static fromFormGroup(
		fg: FormGroup<CallingTreeAssignmentsFormGroup>
	): UpdatedCallingTreeAssignments {
		return {
			branch: fg.value.assignments?.branch ?? null,
			activeCoordinatorId: fg.value.activeCoordinatorId,
			backupCoordinatorId: fg.value.backupCoordinatorId,
		};
	}
}

export interface CallingTreeAssignmentsResponse extends BaseResponse {
	message: string;
	dropdowns: UserDropDownJSON[];
	assignments: CallingTreeAssignmentsJSON;
}

export interface CallingTreeAssignmentsFormGroup {
	assignments: FormControl<CallingTreeAssignments>;
	activeCoordinatorId: FormControl<number>;
	backupCoordinatorId: FormControl<number>;
}

export interface UpdatedCallingTreeAssignments {
	branch: number;
	activeCoordinatorId: number;
	backupCoordinatorId: number;
}
